import { TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RouterLink } from "@angular/router";
import { Relationship } from "@models/relationships/relationship";
import { RelationshipType, RelationshipTypeLabels } from '@models/relationships/relationship-type.enum';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { DividerComponent } from "@shared/components/commons/divider/divider.component";
import { CountryPipe } from "@shared/pipes/countryPipe";
import { DateFormatPipe } from "@shared/pipes/dateFormatPipe";
import { DefaulValuePipe } from "@shared/pipes/defaultValuePipe";
import { DinPipe } from "@shared/pipes/din.pipe";
import { OfficerStatusPipe } from "@shared/pipes/officerStatusPipe";
import { OfficeholderGroupModel } from "../../../../models/officeholder-group-model";

@Component({
  selector: 'app-officeholder-profile',
  standalone: true,
  imports: [
    DividerComponent,
    RouterLink,
    DefaulValuePipe,
    OfficerStatusPipe,
    TitleCasePipe,
    DateFormatPipe,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdownItem,
    DinPipe
  ],
  templateUrl: 'officeholder-profile.component.html',
  styleUrl: 'officeholder-profile.component.scss'
})
export class OfficeholderProfileComponent implements OnInit {
  @Input() officeholder!: OfficeholderGroupModel;
  @Input() isPendingChangesVisible = true;
  @Input() disableControls = false;

  @Output() profileViewChange = new EventEmitter<boolean>();
  @Output() ceaseRegisteredAgent = new EventEmitter<Relationship[]>();
  @Output() companyChangePartyName = new EventEmitter<string[]>();
  @Output() changeOfficerAddress = new EventEmitter<string[]>();
  @Output() editOfficer = new EventEmitter<Relationship>();

  readonly RelationshipType = RelationshipType;

  isSomeDirector = false;
  placeOfBirth = '';
  typesLabel = '';

  ngOnInit(): void {
    this.isSomeDirector = this.officeholder.types.includes(RelationshipType.Director) || this.officeholder.types.includes(RelationshipType.AlternativeDirector);
    this.placeOfBirth = CountryPipe.formatPlaceOfBirth(this.officeholder.birthCity, this.officeholder.birthCountry);
    this.typesLabel = this.officeholder.types.map((type) => RelationshipTypeLabels[type]).join(', ');
  }

  onCeaseRegisteredAgent(): void {
    this.ceaseRegisteredAgent.emit(this.officeholder.relationships);
  }

  onCompanyChangePartyName(): void {
    this.companyChangePartyName.emit(this.officeholder.relationshipIds);
  }

  onChangeOfficerAddress(): void {
    this.changeOfficerAddress.emit(this.officeholder.relationshipIds);
  }

  onEditOfficer(): void {
    this.editOfficer.emit(this.officeholder.relationships[0]);
  }
}
